import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'react-toastify'
import { useMembersStore } from '../store/membersStore'
import { updateMember } from '../utils/updateMember'
import type { ApiError } from '@/types/api'
import { notifyRequestError } from '@/utils/notifyRequestError'
import { DONATIONS } from '@/features/donations/constants/endpoints'

export const useUpdateMemberMutation = (onSuccess?: () => void) => {
  const update = useMembersStore((state) => state.update)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: updateMember,
    onSuccess: ({ message, member, hadUpdatedDonations }) => {
      update(member)

      if (hadUpdatedDonations) {
        queryClient.invalidateQueries({ queryKey: [DONATIONS] })
      }

      toast.success(message || 'Member edited successfully.')
      onSuccess?.()
    },
    onError: (error: ApiError) => {
      notifyRequestError(error, 'An error occurred while editing member.')
    },
  })
}
